import { useState } from "react";
import { Botao } from "../../../shared/components/Botao";
import { LoadingPage } from "../../../shared/components/LoadingPage";
import { Sidebar } from "../../../shared/components/MenuSidebar/Sidebar";
import { ConfirmDeleteModal } from "../../../shared/components/Modal/ConfirmDeleteModal";
import { Navbar } from "../../../shared/components/Navbar";
import { PageHeader } from "../../../shared/components/PageHeader/PageHeader";
import { TableInfo } from "../../../shared/components/Table";
import { IconAdicionar } from "../../../shared/Icons/IconAdicionar";
import { IconContatos } from "../../../shared/Icons/IconContatos";
import { IconVisibility } from "../../../shared/Icons/IconVisibility";
import { ContatoModal } from "../components/ContatoModal";
import { EditContatoModal } from "../components/EditContatoModal";
import { SimpleFilter } from "../components/SimpleFilter";
import useGetContatos from "../hooks/useGetContatos";
import { colunas } from "../utils/columnTableContatos";
import useDeleteContato from "../hooks/useDeleteContato";

export function Contatos() {
  const [visible, setVisible] = useState<boolean>(false);
  const [visibleEdit, setVisibleEdit] = useState(false);
  const [visibleDelete, setVisibleDelete] = useState(false);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");
  const [page, setPage] = useState<number>(1);
  const [valueInput, setValueInput] = useState("");
  const [contatoId, setContatoId] = useState<number>();

  const { data: contatos, isLoading } = useGetContatos(search, page);
  const { mutate: deleteContato } = useDeleteContato(() => handleCloseLaterDelete());

  const contatosData = contatos?.items.map((contato: any) => ({
    key: contato.ContatoId,
    ContatoNome: contato.Nome + " " + contato.Sobrenome,
    ...contato,
  }))

  function getForEdit(record: any) {
    setContatoId(record.ContatoId);
    setVisibleEdit(!visibleEdit);
  }

  function handleCloseLaterDelete() {
    setVisibleDelete(!visibleDelete);
    setLoading(false);
  }

  async function onDelete() {
    deleteContato(Number(contatoId));
    setLoading(true);
    setContatoId(undefined);
  }

  const columns = [
    ...colunas,
    {
      title: "Ações",
      dataIndex: "action",
      key: "action",
      width: 50,
      render: (text: any, record: any, index: any) => {
        return (
          <div className=" flex justify-center">
            <button
              onClick={() => {
                getForEdit(record);
              }}
              className="bg-gray-400 hover:bg-primary-hover p-1 text-gray-100 rounded-full"
            >
              <IconVisibility width="20" height="20" />
            </button>
          </div>
        );
      },
    },
  ];

  return (
    <div className="flex flex-row mx-auto">
      <div className="flex flex-row">
        <Sidebar />
        <Navbar />
      </div>
      <div className="flex flex-col pl-[10rem] w-[85%] mx-auto">
        <PageHeader
          titulo="Contatos"
          icon={<IconContatos />}
          componente={
            <div className="flex gap-10">
              <SimpleFilter
                placeholder="Pesquisar contato"
                value={valueInput}
                onChange={(e: any) => setValueInput(e.target.value)}
                onClick={() => {
                  setSearch(valueInput)
                  if(valueInput) {
                    setPage(1);
                  }
                }}
                onCancel={() => {
                  setSearch("");
                  setValueInput("");
                }}
              />
              <Botao
                texto="Novo"
                icon={<IconAdicionar color="#fff" />}
                onClick={() => setVisible(!visible)}
                className="h-[2.55rem] bg-primary hover:bg-primary-hover text-white"
              />
            </div>
          }
        />

        {contatoId ? (
          <EditContatoModal
            visible={visibleEdit}
            onCancel={() => {
              setContatoId(undefined);
              setVisibleEdit(!visibleEdit);
            }}
            contatoId={contatoId}
            deleteModal={() => {
              setVisibleDelete(!visibleDelete);
              setVisibleEdit(!visibleEdit);
            }}
          />
        ) : (
          <ContatoModal
            onCancel={() => setVisible(!visible)}
            visible={visible}
          />
        )}

        {!contatos ? (
          <div className="h-[80vh] flex justify-center items-center">
            <LoadingPage />
          </div>
        ) : (
          <TableInfo
            loading={isLoading}
            columns={columns}
            dataSource={contatosData}
            pagination={{
              current: page,
              pageSize: contatos?.meta?.itemsPerPage,
              total: contatos?.meta?.totalItems,
              onChange(p) {
                setPage(p);
              },
            }}
          />
        )}

        <ConfirmDeleteModal
          isModalOpen={visibleDelete}
          title="Excluir Contato"
          mensagem="Você tem certeza que desejar excluir o contato?"
          onDelete={onDelete}
          isLoading={loading}
          closeModal={() => setVisibleDelete(!visibleDelete)}
        />
      </div>
    </div>
  );
}
